// extracted by mini-css-extract-plugin
module.exports = {"label":"NumberInput_label__1RYA6","input":"NumberInput_input__Tq3oY"};